// actions/catalog/search.js

import { attachAuth } from '../../utils/authService';

// --- ALL ---

export function searchHasErrored(bool) {
  return {
    type: 'SEARCH_HAS_ERRORED',
    hasErrored: bool
  };
}

export function searchIsLoading(bool) {
  return {
    type: 'SEARCH_IS_LOADING',
    isLoading: bool
  };
}

export function searchFetchDataSuccess(obj) {
  return {
    type: 'SEARCH_FETCH_DATA_SUCCESS',
    obj
  };
}

export function searchFetchData(host, search, category, sub) {
  return (dispatch) => {
    dispatch(searchIsLoading(true));
    dispatch(searchHasErrored(false));
    fetch(host + 'catalog/search', {
      method: 'post',
      body: JSON.stringify({ search: search, category: category, sub: sub }),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(searchFetchDataSuccess(result));
            dispatch(searchHasErrored(false));
            dispatch(searchIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(searchHasErrored(true));
            dispatch(searchIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(searchHasErrored(true));
      dispatch(searchIsLoading(false));
    });
  };
}